<div class="sidescrolling-logos-panel" #panelEl>
  <h2 class="sidescrolling-logos-panel__title" #titleEl>{{ data.title.value }}</h2>

  <div class="sidescrolling-logos-panel__tracks-wrapper" #wrapperEl>
    <div
      *ngFor="let row of logoRows; let i = index"
      [class.empty]="row.length === 0"
      class="sidescrolling-logos-panel__carousel-track"
    >
      <app-autoscroll-image-carousel
        [imageList]="row"
        [direction]="i % 2 === 0 ? 'ltr' : 'rtl'"
        [grayscaleImages]="data.grayscaleLogos.value">
      </app-autoscroll-image-carousel>
    </div>
  </div>
</div>
